// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2d-F-","label":"Category_label__2NdEm","content":"Category_content__3G6Yu","header":"Category_header__3jarW","location":"Category_location__3smOe"};